import { createAction } from 'redux-actions';
// Handle the change event
export var mentionSearchChange = createAction("MENTION.SEARCH_CHANGE", function (_a) {
    var value = _a.value, setMentions = _a.setMentions;
    return ({ value: value, setMentions: setMentions });
});
// Cache all users found on the page
export var initOnPageUsers = createAction("MENTION.INIT_ON_PAGE_USERS", function (users) { return ({ users: users }); });
// Store server friends list
export var populateFriends = createAction("MENTION.POPULATE_FRIENDS", function (alpha, friends, page) { return ({
    alpha: alpha,
    friends: friends,
    page: page,
}); });
//# sourceMappingURL=actionCreators.js.map